import React from 'react'
import styles from './index.module.css'

const Index = ({
  text = 'Сохранить',
  type = 'primary',
  mr = '.5rem',
  icon: Icon,
  ...props
}) => {
  const typeButton = styles[type] || ''

  return (
    <button
      {...props}
      className={typeButton + ' ' + styles.button}
      style={{
        margin: mr,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: Icon ? '9.5px 10px' : '8px 12px',
      }}
    >
      {Icon ? <Icon /> : text}
    </button>
  )
}

export default Index